export const API_REFERRAL_LINK_SUCCESS = "API_REFERRAL_LINK_SUCCESS";
export const API_REFERRAL_LINK_FAIL = "API_REFERRAL_LINK_FAIL";
export const GET_REFERRAL_LINK = "GET_REFERRAL_LINK";
